import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  TemplateRef,
  ViewChild
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import * as _ from "lodash";
import * as fromRootStore from "../../../reducers";
import {
  Combo2Service,
  ExcelService,

  PurchaseReportService
} from "../../../services/index";
import { SalesOrderService } from "../../../services";
declare var google;

@Component({
  selector: "purchaseOrder",
  host: { "(window:keydown)": "hotkeys($event)" },
  templateUrl: "./settings.html",
})
export class settingsComponent implements OnInit {

  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  gridOptions: any;
  dataList = [];
  qualityList: any;
  // typeList = ["RECEIVED", "PENDING", "BULK PENDING - ALL PARTY"];

  codeList: any;
  widthList: any[];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  isChecked = false;
  finyearList = [];
  exceldata: any;
  columns = [];
  partycodeList = [];
  toggleCol = [];
  menu: any;
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  swatchList = ["YES", "NO"];
  sampList = ["YES", "NO"];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    public datePipe: DatePipe,
    public toasterService: ToasterService,
    private poservice: SalesOrderService
  ) {

  }

  ngOnInit(): void {
    this.getpageState();
  }
  getpageState() {


    let that = this;
    this.poservice
      .getCurrentpageState("")
      .then(function (res: any) {
        that.isChecked = res.data;
      });
      setTimeout(() => {
        console.log("OMMMMMMMMM",that.isChecked) 
      }, 2000);
      
  }
  onToggle(isChecked) {

    let params = {
      open_type: isChecked
    };
    let that = this;
    this.isLoadMask = this.poservice
      .controlsalesPage(params)
      .then(function (res: any) {
        that.loadingIndicator = false;


      });
  }



}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Sales/settingControl/settings.ts